import { AbstractControl, UntypedFormControl } from '@angular/forms';

export function SFAValidator(control: UntypedFormControl): { [s: string]: boolean } {
  if (
    control.value !== null &&
    control.value !== '' &&
    !control.value.match(/^[0-9]+$/)
  ) {
    return { invalidSFANumber: true };
  }
  return null;
}

export function shipLocationValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  if (
    control.value !== null &&
    control.value !== '' &&
    !control.value.match(/[A-Z0-9]{6}/)
  ) {
    return { locationTooShort: true };
  }
  return null;
}

export function disboNameValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  if (
    control.value !== null &&
    control.value !== '' &&
    control.value !== '' &&
    !control.value.match(/^[A-Za-z0-9 \-\.]+$/)
  ) {
    return { invalidDisboName: true };
  }
  return null;
}

export function phoneValidator(control: UntypedFormControl): { [s: string]: boolean } {
  if (
    control.value !== null &&
    control.value !== '' &&
    !control.value.match(/^([0-9]{10,14})$/)
  ) {
    return { invalidPhone: true };
  }
  return null;
}

export function lsrContactValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  if (
    control.value !== null &&
    control.value !== '' &&
    !control.value.match(/[A-Za-z0-9 \-\.]+/)
  ) {
    return { invalidLsrContact: true };
  }
  return null;
}

export function roundTripHomeportValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  if (
    control.value !== null &&
    control.value !== '' &&
    !control.value.match(/^[A-Za-z0-9 \-\.\,]+$/)
  ) {
    return { invalidHomePort: true };
  }
  return null;
}

export function roundTripDSSNValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  if (
    control.value !== null &&
    control.value !== '' &&
    !control.value.match(/[0-9]{4}/)
  ) {
    return { invalidDssn: true };
  }
  return null;
}

export function disboEmailValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  const emailRegex = new RegExp(
    "/[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[A-Za-z0-9!#$%&" +
      "'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\\.)" +
      '+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?/'
  );
  if (
    control.value !== null &&
    control.value !== '' &&
    !control.value.match(emailRegex)
  ) {
    return { invalidDisboEmail: true };
  }
  return null;
}

export function quantityValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  if (control.value === undefined || !control.value) {
    return null;
  }
  if (control.value <= 0) {
    return { quantityBelowOne: true };
  }

  if (!control.value.match(/[0-9]+/)) {
    return { quantityNonNumeric: true };
    // return "Quantity should be a number";
  }
  return null;
}

export function shipNameValidator(
  control: UntypedFormControl
): { [s: string]: boolean } {
  if (
    control.value !== null &&
    control.value !== '' &&
    !control.value.match(/^[A-Za-z0-9 \-."']+$/)
  ) {
    return { invalidShipName: true };
  }
  return null;
}
